import React, { useRef } from 'react'
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { isFeatureEnabledProfile } from '../../util/helpers';
import { TextWrap } from "../../util/showmore";
import { handleCallServiceMessage } from "./CallService";
import * as constants from "./constants";
import { GetAgentPhotoOrInitial } from "./helpers";
import SecondsTimer from '../../components/SecondsTimer';

export function CallInitiation(props) {
  const { callFlow } = props;

  const dispatch = useDispatch();
  const auto_answer = isFeatureEnabledProfile('auto_answer')
  const auto_answer_delay_value = isFeatureEnabledProfile('auto_answer_delay_value') == 0 ? 1 : isFeatureEnabledProfile('auto_answer_delay_value');
  const sip_call_event_type = useSelector((state) => {
    return state.ticker.sip_call_event_type;
  }, shallowEqual);

  const sip_call_event = useSelector((state) => {
    return state.ticker.sip_call_event;
  }, shallowEqual);

  const call_state = useSelector((state) => {
    return state.ticker.call_state;
  }, shallowEqual);

  const agentAnswerEvent = useSelector((state) => {
    return state.ticker.agentAnswerEvent;
  }, shallowEqual);

  const agentAnswered = useSelector((state) => {
    return state.ticker.agentAnswered;
  }, shallowEqual);

  const customerCalled = useSelector((state) => {
    return state.ticker.customerCalled;
  }, shallowEqual);
  const dialerType = useSelector((state) => {
    return state.ticker.dialerType;
  }, shallowEqual);

  const firstCallAnswerEvent = useSelector((state) => {
    return state.ticker.firstCallAnswerEvent;
  }, shallowEqual);

  const [actionsEnabled, setActionsEnabled] = useState(false);
  const sip_connected = useSelector((state) => state.ticker.sip_connected);

  const [actionTaken, setActionTaken] = useState(false);

  const audio = useRef(null);

  const [showTimer, setShowTimer] = useState(false);
  const [autoAnswerFlag, setAutoAnswerFlag] = useState(false);

  const playSound = async () => {
    audio.current.loop = true
    await audio.current.play();
  }

  useEffect(() => {
    const RING_TONE = "https://webrtc-audio.knowlarity.com/tring_3_times.mp3";
    let _audio = new Audio(RING_TONE);
    audio.current = _audio;
  },[])

  useEffect(() => {
    if (sip_call_event_type === "invited")
      playSound();
    
    if (sip_call_event_type === "invited" || sip_call_event_type === "ongoing")
      setActionsEnabled(true);

    return () => {
      if (audio.current) {
        audio.current.pause();
      }
    }
  }, [sip_call_event_type])

  useEffect(() => {
    if (sip_call_event_type === "invited") {
      if (auto_answer && props.callFlow.isSipCall() && !agentAnswered && !autoAnswerFlag) {
        setShowTimer(true);
        setAutoAnswerFlag(true);
        setTimeout(() => {
          audio.current.pause();
          acceptCall();
        }, parseInt(auto_answer_delay_value) * 1000);
      }
    }
  },[sip_call_event_type, autoAnswerFlag])

  useEffect(() => {
    if (
      (call_state === constants.CALL_STATES.CALL_HANGUP ||
        call_state === constants.CALL_STATES.CALL_CONNECTED) &&
      audio.current
    ) {
      audio.current.pause();
    }
  }, [call_state]);

  const acceptCall = () => {

    if (audio.current) {
      audio.current.pause();
    }

    //accept SIP call
    if (props.callFlow.isSipCall()) {
      dispatch({
        type: "onSetTickerState",
        payload: {
          sip_command: { type: "accept" },
        },
      });
    }
    setActionTaken(true);
  };

  const cancelCall = () => {
    setActionTaken(true);
    if (audio.current) {
      audio.current.pause();
    }
    if (!actionTaken && !firstCallAnswerEvent) {
      dispatch({
        type: "onSetTickerState",
        payload: {
          sip_command: { type: "reject" },
        },
      });
    } else {
      dispatch({
        type: "onSetTickerState",
        payload: {
          sip_command: { type: "hangup" },
        },
      });
    }
    return;
  };

  const handleTimerComplete = () => setShowTimer(false);

  return (
    <>
      <div className="c2c_widget_header widget_header ctc-header">
        <div className="header-content">
          <div className="oval">
            <span className="brand-logo1">
              <img
                alt=""
                className="brand-logo"
                src={toAbsoluteUrl("/media/sr/logos/menu-brand-logo.svg")}
              />
            </span>
          </div>
          <div className="heading">Super Receptionist</div>
        </div>
        <div
          className="header-close"
          onClick={() => {
            dispatch({ type: "Close", payload: {} });
          }}
        >
          <img
            alt=""
            className="header-close-icon"
            draggable="false"
            src={toAbsoluteUrl("/media/sr/icons/close-red.svg")}
          />
        </div>
      </div>
      <div className="ticker-body">
        <div className="incoming-call-section">
          {props.callFlow.isSipCall() && (
            <>
              {(props.callFlow.getCallSolutionName() === "c2c" &&
                !customerCalled) ||
              (props.callFlow.getCallSolutionName() === "obdcc" &&
                props.callFlow.state.call_type !== "legc_call" &&
                !customerCalled) ? (
                //&& !agentAnswered
                <>
                  <div className="incoming-sec">
                    <div className="row justify-content-center text-center">
                      <div className="call-type text-center">
                        Incoming Call Notification
                      </div>
                    </div>
                    <div className="row justify-content-center text-center">
                      <div className="call-type text-center">
                        On Your SIP ID
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="incoming-number"></div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {props.callFlow.getCallSolutionName() === "obdcc" &&
                  dialerType === "predictive" ? (
                    <>
                      <div className="incoming-sec">
                        <div className="row justify-content-center text-center">
                          <div className="call-type text-center">
                            Please wait while we connect you
                          </div>
                          <div className="call-type text-center">
                            with one of the Customers
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row justify-content-center ">
                        <div className="user-photo-sec ">
                          <GetAgentPhotoOrInitial
                            agent={{
                              first_name: callFlow.getCustomerName(),
                              last_name: null,
                            }}
                            wrapCls="user-photo"
                            imgCls="user-photo-icon"
                          />
                        </div>
                      </div>
                      <div className="incoming-sec">
                        <div className="row justify-content-center">
                          <div className="call-type">
                            {props.callFlow.isIncoming()
                              ? "You are getting a call from"
                              : "We are making a call to"}
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className="incoming-number">
                            {props.callFlow.getCustomerNumber()}
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className="incoming-name">
                            <TextWrap
                              text={props.callFlow.getCustomerName()}
                              max={20}
                            />
                            {callFlow.state.callInitialEvent &&
                              callFlow.state.callInitialEvent
                                .variable_sticky_agent === "1" && (
                                <span className="ml-1">
                                  <img
                                    alt=""
                                    style={{
                                      verticalAlign: "top",
                                      borderStyle: "none",
                                      height: "22px",
                                      marginTop: "-4px",
                                    }}
                                    className="sticky-ag "
                                    draggable="false"
                                    src={toAbsoluteUrl(
                                      "/media/sr/icons/sticky-agent.svg"
                                    )}
                                  />
                                </span>
                              )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {!props.callFlow.isSipCall() && (
            <>
              {props.callFlow.getCallSolutionName() === "obdcc" &&
              dialerType === "predictive" ? (
                <>
                  <div className="incoming-sec">
                    <div className="row justify-content-center text-center">
                      <div className="call-type text-center">
                        Please wait while we connect you
                      </div>
                      <div className="call-type text-center">
                        with one of the Customers
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row justify-content-center ">
                    <div className="user-photo-sec ">
                      <GetAgentPhotoOrInitial
                        agent={{
                          first_name: callFlow.getCustomerName(),
                          last_name: null,
                        }}
                        wrapCls="user-photo"
                        imgCls="user-photo-icon"
                      />
                    </div>
                  </div>
                  <div className="incoming-sec">
                    <div className="row justify-content-center">
                      <div className="call-type">
                        {props.callFlow.isIncoming()
                          ? "You are getting a call from"
                          : "We are making a call to"}
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="incoming-number">
                        {props.callFlow.getCustomerNumber()}
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="incoming-name">
                        <TextWrap
                          text={props.callFlow.getCustomerName()}
                          max={20}
                        />
                        {callFlow.state.callInitialEvent &&
                          callFlow.state.callInitialEvent
                            .variable_sticky_agent === "1" && (
                            <span className="ml-1">
                              <img
                                alt=""
                                style={{
                                  verticalAlign: "top",
                                  borderStyle: "none",
                                  height: "22px",
                                  marginTop: "-4px",
                                }}
                                className="sticky-ag "
                                draggable="false"
                                src={toAbsoluteUrl(
                                  "/media/sr/icons/sticky-agent.svg"
                                )}
                              />
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          <div className="via-sec">
            <div className="row justify-content-center">
              <div className="via-text">Via SR Number</div>
            </div>
            <div className="row justify-content-center">
              <div className="via-number">
                {props.callFlow.state.callEvent["knowlarity_number"]}
              </div>
            </div>
          </div>
          {props.callFlow.hasQueue() && props.callFlow.getQueueName() && (
            <div className="row justify-content-center call-desc-sec">
              <div className="call-desc">
                Queue:{" "}
                <TextWrap text={props.callFlow.getQueueName()} max={25} />
              </div>
            </div>
          )}

          {props.callFlow.isSipCall() && sip_connected &&  (
            <div className="row justify-content-center call-action-sec">
              {!agentAnswered && (
                <>
                  {(auto_answer && showTimer && (auto_answer_delay_value && auto_answer_delay_value > 1)) &&
                    <div className={"d-flex justify-content-center"}>
                      <SecondsTimer initialTime={parseInt(auto_answer_delay_value)} onComplete={handleTimerComplete} />
                    </div>}
                  {!auto_answer &&
                    <div
                      className={`${actionsEnabled && !actionTaken ? "" : "action-disabled"} pick-call click-icon`}
                    >
                      <a
                        href="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          acceptCall();
                        }}
                      >
                        <img
                          alt=""
                          className="dial-call-icon"
                          draggable="false"
                          src={toAbsoluteUrl("/media/sr/icons/dial-call.svg")}
                        />
                      </a>
                    </div>}
                </>
              )}
              {((!agentAnswered && !customerCalled) ||
                props.callFlow.getCallSolutionName() !== "obdccdddd") && !auto_answer && (
                <div
                  className={`${actionsEnabled ? "" : "action-disabled"} disconnect-call click-icon`}
                >
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      cancelCall();
                    }}
                  >
                    {" "}
                    <img
                      alt=""
                      className="dial-call-icon"
                      draggable="false"
                      src={toAbsoluteUrl("/media/sr/icons/disconnect-call.svg")}
                    />
                  </a>
                </div>
              )}
            </div>
          )}
          {props.callFlow.isSipCall() && !sip_connected &&
            <div className='d-flex justify-content-center mt-5'> 
              <p className='text-center' style={{ color: 'red' }}><i>WebRTC/SIP connection lost. Please establish connection and try again.</i></p> 
            </div>
          }
          {props.callFlow.isSipCall() && sip_connected && !actionsEnabled &&
            <div className='d-flex justify-content-center mt-12'> 
              <p className='text-center' style={{ color: 'red' }}><i>Please wait 10 seconds. If you're still unable to take any action on the call, kindly refresh your browser.</i></p> 
            </div>
          }
        </div>
      </div>
    </>
  );
}
